export default __webpack_public_path__ + "static/media/Vikas.fe0cff7b.png";